import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QRButtonWrapper } from '@base/src/app/models/qr-button-wrapper.model';

@Component({
  selector: 'qr-button-wrapper',
  templateUrl: './button-wrapper.component.html',
  styleUrls: ['./button-wrapper.component.scss'],
})
export class ButtonWrapperComponent {
  @Input() config!: QRButtonWrapper;
  @Output() configChange: EventEmitter<QRButtonWrapper> =
    new EventEmitter<QRButtonWrapper>();
  select(): void {
    this.config = { ...this.config, isSelected: !this.config.isSelected };
    this.configChange.emit(this.config);
  }
}
